import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import renewalOption from "../fragments/renewalOption"

const query = gql`
  query GetRenewalQuote($businessId: ID!) {
    salesRenewalQuote(businessId: $businessId) {
      status
      statusMessage
      seats
      currency
      products {
        id
        name
        costPerSeatMonth
        seats
        recurringChargeId
        usageChargeId
      }
      options {
        ...renewalOption
      }
      signatureContact {
        firstName
        lastName
        email
        telephone
      }
      etag
      winbackOption {
        ...renewalOption
      }
      errorType
      errorMessage
      isManual
      sentForSignature {
        seconds
      }
      createdAt {
        seconds
      }
      signedAt {
        seconds
      }
    }
  }
  ${renewalOption}
`

export const getRenewalQuoteKey = getQueryNames(query)[0]

export default query
